import React from 'react';
import {Link} from 'react-router-dom';
import {Path} from '../Path.js';




function Banner(){

    return(
    <>
  
{/* // <!-- Container (About Section) -->  */}
<div id="banner" className="container-fluid">
  <div className="row">
  
    <div className="col-sm-8">
        <h1 className='home_heading'>Hold <span className='change-color'>$LITTLE</span><br />Earn Revenue</h1>
        <b><p className='banner-para first'>And get access to a world of staking, holding and using like never seen before.</p></b>
        <p className='banner-para home_p'>$LITTLE is the Little Billionaires utility token. <br />Earn $LITTLE as an NFT holder through staking, get rewarded with <br /> MATIC tokens every day for owning your $LITTLE and enjoy many <br />exclusive benefits associated with this token.</p>
        <div className='btn-block'>
        <a href={Path+"Whitepaper_FINAL_1.1-2.pdf"} target="_blank" rel="noreferrer" className="whitepaper">
          <button className="custom-btn btn-banner">Whitepaper</button>
        </a>
        <Link  className="whitepaper" to="/">
          <button className="custom-btn btn-banner second">Get NFT</button>
        </Link>
        </div>
    </div>
    <div className="col-sm-4 picture">
      <img src={'images/banner.png'} alt="banner" className='banner-pic floating'/>
    </div>
  </div>
</div>


</>

);


}   

export default Banner;